module.exports = __webpack_public_path__ + "static/img/head-id.a4ec72d4.png";